import makeStyles from '@mui/styles/makeStyles';

/**
 * @typedef {
    | 'search'
    | 'xOfYText'
    | 'toolbar
    | 'links'
    | 'link'
 * } ClassNames
 */

export const useStyles = makeStyles(
    /**
     * @returns {Record<ClassNames | keyof import('@mui/x-data-grid').GridClasses, import('@mui/styles').CSSProperties>}
     */
    theme => ({
        search: {
            marginBottom: theme.spacing(4)
        },
        xOfYText: {
            marginBottom: theme.spacing(2)
        },
        toolbar: {
            justifyContent: 'flex-end',
            paddingRight: 0,
        },

        root: {
            border: 'none',

            // Nesting required for priority
            '& $cell': {
                borderBottomColor: '#B7B7B7',
            },

            // Not properly overridable, so must use global class
            '& .MuiDataGrid-columnsContainer': {
                borderBottomColor: '#3C3C3C',
            },
        },

        // Empties required for nesting, and recognition for overrides
        row: {},
        cell: {
            // Allow children to absolute over their cell
            position: 'relative',

            // Disable weird cell-select outline
            outline: [['none'], '!important'],
        },
        columnHeader: {
            // Disable weird cell-select outline
            outline: [['none'], '!important'],

            // Not properly overridable, must use global class
            '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: theme.typography.fontWeightBold,
            },

            // Not properly overridable, must use global class
            '& .MuiDataGrid-columnHeaderTitleContainer': {
                // Fixes title/content alignment
                paddingLeft: 0,
            },
        },

        // Added to root when links variant enabled
        links: {
            '& $row': {
                cursor: 'pointer',
            },

            // Disable default link styling
            '& a': {
                color: 'inherit',
                textDecorationLine: 'none',
            },
        },

        // Make link area cover the entire cell
        link: {
            display: 'flex',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,

            // Inherit cell padding to keep styling correct
            padding: 'inherit',
            alignItems: 'center',
        },

        // Root when using ordered checkboxes - hides the real checkboxes
        orderedCheckboxes: {
            '& .MuiDataGrid-columnHeaderCheckbox': {
                display: [['none'], '!important'],
            },
            '& .MuiDataGrid-cellCheckbox': {
                display: [['none'], '!important'],
            },
        }
    })
);